import { atom } from 'recoil';

export interface Vector3 {
  x: number;
  y: number;
  z: number;
}

export interface Slice {
  start: number;
  stop: number;
}

export interface ParameterSpace {
  lower: number;
  upper: number;
}

export interface Parameter {
  name: string;
  controlPoints: Vector3;
  morphingMin: Vector3;
  morphingMax: Vector3;
  ySymmetry: boolean;
  targetControlPointsX: Slice;
  targetControlPointsY: Slice;
  targetControlPointsZ: Slice;
  morphingDirection: string;
  morphingParameter: ParameterSpace;
}

export const parameterListState = atom<Parameter[]>({
  key: 'parameterListState',
  default: []
});
